import { message } from '@linktivity/link-ui';
import { Firebase } from '@linktivity/link-utils';
export type { User, UserCredential } from '@linktivity/link-utils';
import i18n from '@link/share/i18n';
import { BaseAuth } from '@link/share/stores';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_APP_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN,
  tenantId: import.meta.env.VITE_APP_FIREBASE_TENANT_ID
};

const tenantId = import.meta.env.VITE_APP_FIREBASE_TENANT_ID;

class ShareAuth extends Firebase {
  constructor(auth: BaseAuth) {
    super(firebaseConfig);
    this.setTenantId(tenantId);

    this.auth.onAuthStateChanged(user => {
      if (user) {
        auth.setUser(user);
      } else {
        auth.clearUser();
      }
    });
  }

  showErrorMessage(error: unknown) {
    // Type guard for Firebase error objects
    if (
      typeof error === 'object' &&
      error !== null &&
      'code' in error &&
      'message' in error &&
      typeof (error as { code: unknown }).code === 'string' &&
      typeof (error as { message: unknown }).message === 'string'
    ) {
      const errorCode = (error as { code: string }).code;
      let errorMessage = (error as { message: string }).message;
      if (i18n.exists(`share.firebase.${errorCode}`)) {
        errorMessage = i18n.t(`share.firebase.${errorCode}`);
      }
      message.error(errorMessage);
    } else {
      message.error(i18n.t('share.firebase.unknownError'));
    }
  }
}

export default ShareAuth;
